import React from 'react';
import {Speaker, TopicMatch} from '@store/call-card/CallCard.types';
import './NarrowTranscriptLine.sass';
import formatSecondsShort from 'utils/formatSecondsShort';
import {UserAvatar} from '@components/util/UserAvatar';
import {Color, Seconds} from '@store/@types/util';
import {List, Map} from 'immutable';
import {TopicId} from '@store/topic-keyword/TopicKeyword.types';
import {boldMatchText} from '@components/call-card/TranscriptMatch.utils';
import cn from 'classnames';

interface NarrowTranscriptLineProps {
  chunk: string;
  startTime: Seconds;
  speaker: Speaker | undefined;
  matches: List<TopicMatch>;
  activeTopics: Map<TopicId, Color>;
  onClick: () => void;
  highlightLine: boolean;
}

export const NarrowTranscriptLine: React.FC<NarrowTranscriptLineProps> = ({
  chunk,
  startTime,
  matches,
  activeTopics,
  speaker,
  onClick,
  highlightLine,
}) => {
  const colors = matches.map(m => activeTopics.get(m.id)!).toSet();

  return (
    <div
      onClick={onClick}
      className={cn(`narrow-transcript-line transcript-line-${Math.floor(startTime)}`, {
        highlight: highlightLine,
      })}>
      <UserAvatar user={speaker} />
      <div className="message">
        <span className="chunk" dangerouslySetInnerHTML={{__html: boldMatchText(chunk, matches)}} />
        &nbsp;
        <span className="time">{formatSecondsShort(startTime)}</span>
      </div>
      <div className="match-bars">
        {colors.map(c => (
          <div key={c} className="match-bar" style={{backgroundColor: c}} />
        ))}
      </div>
    </div>
  );
};
